import api from './api'

export default class PersonalService {
  static getAccounts() {
    return api.get('/accounts')
  }

  static getAccountsExtended() {
    return api.get('/accounts_extended')
  }

  static exportData(dates) {
    return api.post('/export', dates)
  }

  static getExportStatus() {
    return api.get('/get_export_status')
  }
}
